// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2716":"a8115251","7137":"182128fd","9600":"11c5b3d1"}[chunkId] + ".chunk.css";
};